'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { FaDiscord } from 'react-icons/fa6';
import MatrixGrid from '@/app/components/MatrixGrid';

export default function ChallengesPage() {
    const slotChallenges = [
        {
            name: 'Wanted Salvation',
            casino: 'Stake',
            target: '1,500x',
            minBet: '$0.20',
            reward: '$50',
            img: '/img/slots/hacksaw_wantedsalvation.webp',
            description: 'First to hit 1,500x with minimum $0.20 bet',
            label: 'ONE CLAIM PER USER'
        },
        {
            name: 'Sugar Gates 1000',
            casino: 'Stake',
            target: '1,500x',
            minBet: '$0.20',
            reward: '$50',
            img: '/img/slots/colorfulplay_sugargates1k.webp',
            description: 'First to hit 1,500x with minimum $0.20 bet',
            label: 'ONE CLAIM PER USER'
        },
        {
            name: 'Big Bass Boom',
            casino: 'Stake',
            target: '1,000x',
            minBet: '$0.20',
            reward: '$50',
            img: '/img/slots/pragmatic_bigbassboom.webp',
            description: 'First to hit 1,000x with minimum $0.20 bet',
            label: 'ONE CLAIM PER USER'
        },
        {
            name: 'Thunder vs Underworld',
            casino: 'Stake',
            target: '1,500x',
            minBet: '$0.20',
            reward: '$50',
            img: '/img/slots/pragmatic_thndervsunderworld.webp',
            description: 'First to hit 1,500x with minimum $0.20 bet',
            label: 'ONE CLAIM PER USER'
        },
        {
            name: 'Gates of Heaven 1000',
            casino: 'Stake',
            target: '1,500x',
            minBet: '$0.20',
            reward: '$50',
            img: '/img/slots/pragmatic_gatesofheaven1000.webp',
            description: 'First to hit 1,500x with minimum $0.20 bet',
            label: 'ONE CLAIM PER USER'
        },
        {
            name: 'Waylanders Cup',
            casino: 'Stake',
            target: '1,500x',
            minBet: '$0.20',
            reward: '$50',
            img: '/img/slots/valkyrie_waylanderscup.webp',
            description: 'First to hit 1,500x with minimum $0.20 bet',
            label: 'ONE CLAIM PER USER'
        },
        {
            name: 'Iron Sight',
            casino: 'Stake',
            target: '1,500x',
            minBet: '$0.20',
            reward: '$50',
            img: '/img/slots/hacksaw_ironsight.webp',
            description: 'First to hit 1,500x with minimum $0.20 bet',
            label: 'ONE CLAIM PER USER'
        },
        {
            name: 'Fist of Demolition',
            casino: 'Stake',
            target: '1,500x',
            minBet: '$0.20',
            reward: '$50',
            img: '/img/slots/hacksaw_fistofdemolition.webp',
            description: 'First to hit 1,500x with minimum $0.20 bet',
            label: 'ONE CLAIM PER USER'
        },
        {
            name: 'Waylanders Forge',
            casino: 'Stake',
            target: '1,500x',
            minBet: '$0.20',
            reward: '$50',
            img: '/img/slots/valkyrie_waylandersforge.webp',
            description: 'First to hit 1,500x with minimum $0.20 bet',
            label: 'ONE CLAIM PER USER'
        }
    ];

    const originalChallenges = [
        {
            name: 'Keno',
            casino: 'Stake',
            target: '500x',
            minBet: '$0.20',
            reward: '$50',
            img: '/img/originals/keno_originals.webp',
            description: 'First to hit 500x with minimum $0.20 bet',
            label: 'ONE CLAIM PER USER'
        },
        {
            name: 'Limbo',
            casino: 'Stake',
            target: '1,000x',
            minBet: '$0.20',
            reward: '$50',
            img: '/img/originals/limbo_originals.webp',
            description: 'First to hit 1,000x with minimum $0.20 bet',
            label: 'ONE CLAIM PER USER'
        },
        {
            name: 'Mines',
            casino: 'Stake',
            target: '1,000x',
            minBet: '$0.20',
            reward: '$50',
            img: '/img/originals/mines_originals.webp',
            description: 'First to hit 1,000x with minimum $0.20 bet',
            label: 'ONE CLAIM PER USER'
        }
    ];

    const stakeUrl = 'https://stake.com/?offer=sokoloco&c=c9bb838557';

    const ChallengeCard = ({ challenge, stakeOnly = false }: { challenge: typeof slotChallenges[0]; stakeOnly?: boolean }) => (
        <div className="relative backdrop-blur rounded-2xl overflow-hidden transition-all duration-300 group">
            {/* Animated glow effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-green-400/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

            <div className="relative z-10 p-6 flex flex-col items-center text-center h-full">

                {/* Status Label */}
                <div className="absolute top-4 right-4 z-20">
                    <span className="bg-green-500 text-black text-xs font-mono font-bold px-3 py-1 rounded-full shadow-lg animate-pulse">
                        {challenge.label}
                    </span>
                </div>

                {/* Game Image */}
                <div className="relative w-full aspect-square mb-4 rounded-xl overflow-hidden transition-transform duration-300 group-hover:scale-105">
                    {/* Blurred background image */}
                    <div className="absolute inset-0">
                        <Image
                            src={challenge.img}
                            alt=""
                            fill
                            className="object-cover blur-2xl opacity-40 scale-110"
                            quality={100}
                        />
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/30 via-purple-500/30 to-orange-500/30 blur-2xl"></div>
                    </div>

                    {/* Dark overlay */}
                    <div className="absolute inset-0 bg-black/20"></div>

                    {/* Front Image */}
                    <div className="relative w-full h-full flex items-center justify-center p-6">
                        <div className="relative w-full h-full">
                            <Image
                                src={challenge.img}
                                alt={challenge.name}
                                fill
                                className="object-contain drop-shadow-2xl"
                                quality={100}
                                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                            />
                        </div>
                    </div>
                </div>

                {/* Casino Logo & Game Name */}
                <div className="mb-4">
                    <div className="inline-flex items-center gap-2 bg-green-500/20 rounded-lg px-3 py-1.5 mb-2">
                        <span className="text-xs font-mono font-bold text-gray-300 whitespace-nowrap">Only on</span>
                        <div className="relative w-10 h-4">
                            <Image
                                src="/img/logos/stakecom.svg"
                                alt={challenge.casino}
                                fill
                                className="object-contain"
                            />
                        </div>
                    </div>
                    <h3 className="text-lg font-mono font-bold text-green-400">{challenge.name}</h3>
                </div>

                {/* Challenge Details */}
                <div className="bg-gradient-to-br from-emerald-600/20 via-emerald-800/20 to-gray-900/20 rounded-xl p-4 mb-4 w-full">
                    <div className="mb-2">
                        <span className="text-4xl font-bold bg-gradient-to-r from-green-300 via-emerald-400 to-green-500 bg-clip-text text-transparent inline-block">
                            {challenge.target}
                        </span>
                    </div>
                    <p className="text-xs text-gray-400 font-mono uppercase mb-1">Min Bet: {challenge.minBet}</p>
                    <div className="mt-3 pt-3 border-t border-green-400/20">
                        <p className="text-2xl font-mono font-bold text-green-400">{challenge.reward}</p>
                        <p className="text-xs text-gray-400 font-mono uppercase mt-1">Reward</p>
                    </div>
                </div>

                {/* CTA Button */}
                <Link
                    href={stakeUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-center bg-gradient-to-br from-emerald-600 via-emerald-800 to-gray-900 rounded-xl shadow-lg hover:shadow-emerald-500/30 transition-all duration-200 px-8 py-3 font-mono font-bold text-gray-200 relative overflow-hidden w-full"
                >
                    <span className="relative z-10">PLAY NOW →</span>
                    <div className="absolute inset-0 bg-gradient-to-r from-green-400/0 via-green-400/30 to-green-400/0 transform -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                </Link>
            </div>
        </div>
    );

    return (
        <div className="mt-15 text-gray-200 min-h-screen overflow-hidden relative">
            <MatrixGrid />
            <div className="flex flex-col items-center justify-center space-y-8 relative z-10 max-w-7xl mx-auto px-4 py-16">

                {/* Header */}
                <div className="text-center mb-12">
                    <h1 className="text-4xl md:text-6xl font-mono font-bold tracking-widest mb-4">
                        <span className="bg-gradient-to-r from-green-400 via-emerald-300 to-green-500 bg-clip-text text-transparent">
                            ACTIVE CHALLENGES
                        </span>
                    </h1>
                    <p className="uppercase text-green-300 font-mono text-sm md:text-base">
                        <span className="inline-block animate-pulse">{'['}</span> Be the first to complete the challenge and win the reward <span className="inline-block animate-pulse">{']'}</span>
                    </p>
                </div>

                {/* Slot Challenges Section */}
                <div className="w-full mb-12">
                    <h2 className="text-2xl md:text-4xl font-mono font-bold text-center mb-8 text-green-400">
                        <span className="inline-block animate-pulse">{'['}</span> SLOTS <span className="inline-block animate-pulse">{']'}</span>
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                        {slotChallenges.map((challenge, index) => (
                            <ChallengeCard key={index} challenge={challenge} stakeOnly />
                        ))}
                    </div>
                </div>

                {/* Original Games Section */}
                <div className="w-full mb-12">
                    <h2 className="text-2xl md:text-4xl font-mono font-bold text-center mb-8 text-green-400">
                        <span className="inline-block animate-pulse">{'['}</span> ORIGINALS <span className="inline-block animate-pulse">{']'}</span>
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {originalChallenges.map((challenge, index) => (
                            <ChallengeCard key={index} challenge={challenge} />
                        ))}
                    </div>
                </div>

                {/* How to Claim Section */}
                <div className="w-full backdrop-blur shadow-sm rounded-2xl overflow-hidden backdrop-blur border-b border-green-400/30 rounded-lg p-8">
                    <h2 className="text-2xl md:text-4xl font-mono font-bold text-center mb-8 text-green-400">
                        <span className="inline-block animate-pulse">{'['}</span> HOW TO CLAIM YOUR REWARD <span className="inline-block animate-pulse">{']'}</span>
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
                        {[
                            { step: '1', title: 'Register on Stake', desc: 'Make sure you are under a referral code: SOKOLOCO' },
                            { step: '2', title: 'Play the Game', desc: 'Choose a challenge and start playing' },
                            { step: '3', title: 'Hit the Target', desc: 'Be the first to reach the multiplier' },
                            { step: '4', title: 'Take Screenshot', desc: 'Capture proof of your win' },
                            { step: '5', title: 'Open Ticket', desc: 'Create a Discord ticket to claim' }
                        ].map((item, idx) => (
                            <div key={idx} className="text-center group/step">
                                <div className="inline-flex items-center justify-center w-12 h-12 bg-green-500 rounded-full text-black text-xl font-bold mb-3 transition-transform duration-300 group-hover/step:scale-110 group-hover/step:rotate-12">
                                    {item.step}
                                </div>
                                <h4 className="text-lg font-mono font-bold text-green-400 mb-2">
                                    {item.title}
                                </h4>
                                <p className="text-sm text-gray-300 font-mono">
                                    {item.desc}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* Important Notes */}
                    <div className="mt-8 pt-8 border-t border-green-400/20 space-y-4">
                        <div className="bg-green-500/10 rounded-xl p-6 text-center">
                            <p className="text-gray-300 font-mono text-sm">
                                After winning, create a ticket in our Discord server with proof of your win. Our team will verify and send your reward!
                                Each user can only claim <span className="text-gray-400 font-bold">ONE challenge reward</span>. Once you claim a reward, you cannot claim another same challenge reward.
                            </p>
                        </div>

                    </div>
                </div>

                <div>
                    {/* CTA */}
                    <Link
                        href="https://discord.com/invite/sokoloco"
                        className="group flex items-center gap-3 px-4 bg-gradient-to-br from-emerald-600 via-emerald-800 to-gray-900 rounded-xl shadow-lg hover:shadow-emerald-500/30 hover:border-green-400 hover: transition-all duration-200 px-8 py-4 font-mono font-bold text-gray-200 relative overflow-hidden">
                        <FaDiscord className="w-4 h-4 lg:w-6 lg:h-6" />
                        <span className="font-mono font-semibold">JOIN DISCORD NOW</span>
                    </Link>
                </div>
            </div>
        </div>
    );
}